import styled from "styled-components"
import { StyledCarousel } from "../../s22_carousel/partials/StyledCarousel"
import { StyledGrid } from "../../s22_grid/partials/StyledGrid"
export interface StyledSectionProps {
  background_color: string
  is_offset: boolean
  offset_amount?: string
  is_group?: boolean
  background_image?: string
  body_offset?: string
}
export interface StyledSectionBackgroundImageProps {
  background_image: string
  background_image_repeat: boolean
  background_image_repeat_options: string
  background_image_position_options: string
}

export const StyledSection = styled.section<StyledSectionProps>`
  ${StyledCarousel} {
    & .swiper-wrapper:after {
      ${(props) =>
        props.background_color === "light" &&
        `background: linear-gradient(to right, rgb(0 0 0 / 1%), ${props.theme.colors.ivory});`}
      ${(props) =>
        props.background_color === "dark" &&
        `background: linear-gradient(to right, rgb(0 0 0 / 1%), ${props.theme.colors.ivoryShadow});`}
    }
  }
  
  padding: 64px 0;
  ${(props) =>
    props.background_image &&
    `
    position: relative;
    `}
  width: 100%;
  // max-width: ${(props) => props.theme.breakPoints.max};
  margin: 0 auto;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 48px 0;
  }
  ${(props) =>
    props.background_color === "light" &&
    `
    background-color: ${props.theme.colors.ivory};
    `}
  ${(props) =>
    props.background_color === "dark" &&
    `
    background-color: ${props.theme.colors.ivoryShadow};
    `}
    ${(props) =>
        props.background_color === "white" &&
        `
        background-color: ${props.theme.colors.white};
        `}
    ${(props) =>
    props.is_offset &&
    `
    padding: 0;
    margin-top: -${props.offset_amount || 0}px;
    background-color: transparent;
    @media (max-width: ${props.theme.breakPoints.tablet}) {
        padding: 0;
    }
    
    & ${StyledGrid}{
        margin: 0;
    }
    `}
    ${(props) =>
    props.is_group &&
    `
    padding: 0;
    @media (max-width: ${props.theme.breakPoints.tablet}) {
        padding: 0;
    }
    
    & section{
        background: transparent;
    }
    `}
    ${(props) => props.body_offset === "16" && `
        padding: 0;
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            padding: 0;
        }
    `}
    ${(props) => props.body_offset === "24" && `
        padding: 0;
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            padding: 0;
        }
    `}
    ${(props) => props.body_offset === "32" && `
        padding: 0;
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            padding: 0;
        }
    `}
    ${(props) => props.body_offset === "48" && `
        padding: 0;
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            padding: 0;
        }
    `}
`

export const StyledSectionBackgroundImage = styled.div<StyledSectionBackgroundImageProps>`
  width: 100%;
  height: 100%;
  top: 0;
  pointer-events: none;
  left: 0;
  position: absolute;
  ${(props) =>
    props.background_image &&
    `
        background-image: url('${props.background_image}');
        background-position: center;
    `}
  ${(props) =>
    props.background_image_repeat_options
      ? `
        background-repeat: ${props.background_image_repeat_options};
    `
      : `
        ${
          props.background_image_repeat
            ? `
            background-repeat: repeat;
        `
            : `
            background-repeat: no-repeat;
            background-size: cover;
        `
        }
    `}
    ${(props) =>
    props.background_image_position_options !== "" &&
    `
        background-position: ${props.background_image_position_options};
    `}
`
export const StyledSectionContainer = styled.div`
  ${(props) => props.theme.mixins.container};
  position: relative;
  z-index: 1;
`

export const StyledSectionIntro = styled.div`
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    min-width: 60%;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 100%;
  }
`
export const StyledSectionLabel = styled.p<StyledSectionProps>`
  ${(props) => props.theme.mixins.label};
  margin-bottom: 8px !important;
`
export const StyledSectionHeading = styled.h2<StyledSectionProps>`
  ${(props) => props.theme.mixins.h2};
  &:after {
    ${(props) => props.theme.mixins.headingAccent};
  }
`
export const StyledSectionDescription = styled.div<StyledSectionProps>`
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.mixins.markdown};
  margin-top: 16px;
`
export const StyledSectionHeaderContent = styled.div`
  & > a,
  & > div {
    margin-top: 16px;
  }
`
export const StyledSectionHighlight = styled.div`
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 40%;
    margin-left: 32px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 100%;
    margin-top: 24px;
  }
`
export const StyledSectionBody = styled.div<StyledSectionProps>`
  ${(props) =>
    props.background_color === "light" &&
    `
            background-color: ${props.theme.colors.white};
        `}
  ${(props) =>
    props.background_color === "dark" &&
    `
            background-color: ${props.theme.colors.darkGrey};
        `}
        ${(props) =>
            props.background_color === "white" &&
            `
            background-color: ${props.theme.colors.white};
            `}
    ${(props) =>
    props.is_offset
      ? `
        padding: 0;
    `
      : ` 
        background-color: transparent;
        
    `}
    ${(props) =>
    props.is_group &&
    `
        margin-top: 0;
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            margin-top: 0;
        }
    `}


    ${(props) => props.body_offset !== "none" && `
        margin-top: -${props.body_offset}px;
    `}
    
    
`
export const StyledSectionHeader = styled.header`
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    display: flex;
    justify-content: space-between;
  }

  & + ${StyledSectionBody}{
    margin-top: 32px;
        @media (max-width: ${props => props.theme.breakPoints.tablet}) {
            margin-top: 24px;
        }
  }
`